import React from 'react';
import './styles.scss'

function Header() {
    return (
        <header className="header">
            <h1>Awesome Product</h1>
            <h2>Mussum Ipsum, cacilds vidis litro abertis</h2>
            <button>Order yours now!</button>
        </header>
    )
}

export default Header;